import angular from 'angular';
import onboardingNewParty from './onboardingNewParty';

export default angular
  .module('components.onboardingNewParty', [])
  .component('onboardingNewParty', onboardingNewParty).name;
